import React, { useEffect, useState } from "react";
import { Badge, IconButton, Tooltip } from "@mui/material";
import { Forum } from "@mui/icons-material";
import { CHAT_OPEN_EVENT, CHAT_UNREAD_EVENT, chatUnreadStore } from "../../services/chatService";
import { useAuth } from "../../contexts/AuthContext";

// Atalho fixo do chat no cabeçalho: sempre visível, com o mesmo contador do FAB. É o caminho
// de volta quando o usuário oculta o balão flutuante (pedido do Hilton, 06/09/2026).
const ChatHeaderButton: React.FC = () => {
  const { user } = useAuth();
  const [unread, setUnread] = useState(chatUnreadStore.total);
  const canChat = !!user && ((user.allowedPages || []).includes("chat") || (user.permissions || []).includes("chat"));

  useEffect(() => {
    const handler = (e: Event) => setUnread((e as CustomEvent<{ total: number }>).detail?.total ?? 0);
    window.addEventListener(CHAT_UNREAD_EVENT, handler);
    return () => window.removeEventListener(CHAT_UNREAD_EVENT, handler);
  }, []);

  if (!canChat) return null;

  return (
    <Tooltip title="Chat">
      <IconButton
        onClick={() => window.dispatchEvent(new CustomEvent(CHAT_OPEN_EVENT))}
        aria-label="Abrir chat"
        size="small"
        sx={{ color: "#8a94a6", "&:hover": { bgcolor: "#f1f3f5", color: "#03B4C6" } }}
      >
        <Badge
          badgeContent={unread}
          color="error"
          overlap="circular"
          sx={{
            "& .MuiBadge-badge": {
              fontWeight: 700,
              fontSize: "0.65rem",
              minWidth: 18,
              height: 18,
              border: "2px solid #fff",
              animation: unread > 0 ? "c4uBlink 1.3s ease-in-out infinite" : "none",
            },
            "@keyframes c4uBlink": { "0%,100%": { opacity: 1 }, "50%": { opacity: 0.35 } },
          }}
        >
          <Forum fontSize="small" />
        </Badge>
      </IconButton>
    </Tooltip>
  );
};

export default ChatHeaderButton;
